
//** This file changes the collection filters to be sticky when scrolling up


(() => {
  let bar = null;
  let initialTop = 0;
  let lastScroll = window.scrollY;

  const refreshBar = () => {
    bar = document.querySelector('.product-facet__meta-bar');
    if (!bar) return;
    // Recompute initialTop only when the bar is in normal flow (not currently sticky).
    if (!bar.classList.contains('is-sticky')) {
      initialTop = bar.offsetTop;
    }
  };

  const onScroll = () => {
    if (!bar || !bar.isConnected) {
      refreshBar();
      if (!bar) return;
    }

    const currentScroll = window.scrollY;

    if (currentScroll < lastScroll && currentScroll > initialTop) {
      bar.classList.add('is-sticky');
    } else {
      bar.classList.remove('is-sticky');
    }

    lastScroll = currentScroll;
  };

  const init = () => {
    refreshBar();
    window.addEventListener('scroll', onScroll, { passive: true });
    // Re-bind whenever the product-facet section re-renders (filter/sort/pagination).
    document.addEventListener('pagination:content-updated', refreshBar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
